import { useEffect } from 'react';
import { useChat } from '../../context/ChatContext';
import { Button } from '../ui/button';
import { Dialog, DialogContent } from '../ui/dialog';
import { Phone, PhoneOff, Video } from 'lucide-react';

export default function IncomingCallDialog({ autoAnswer }) {
  var chat = useChat();
  var callState = chat.callState;
  var acceptCall = chat.acceptCall;
  var rejectCall = chat.rejectCall;

  var handleAccept = function() {
    acceptCall();
  };

  var handleReject = function() {
    rejectCall();
  };

  // Auto-answer if specified (e.g., from push notification deep link)
  useEffect(function() {
    if (autoAnswer) {
      var timer = setTimeout(function() { handleAccept(); }, 500);
      return function() { clearTimeout(timer); };
    }
  }, [autoAnswer]);

  return (
    <Dialog open={true}>
      <DialogContent className="sm:max-w-md">
        <div className="text-center py-6">
          <div className="w-20 h-20 rounded-full bg-forest-100 flex items-center justify-center mx-auto mb-4 animate-pulse">
            {callState.callType === 'video' ? (
              <Video className="w-10 h-10 text-forest-600" />
            ) : (
              <Phone className="w-10 h-10 text-forest-600" />
            )}
          </div>

          <h2 className="text-xl font-semibold mb-1" data-testid="incoming-caller-name">
            {callState.callerName || 'Unknown'}
          </h2>
          <p className="text-muted-foreground mb-6">
            Incoming {callState.callType === 'video' ? 'video' : 'voice'} call...
          </p>

          <div className="flex items-center justify-center gap-6">
            <Button
              variant="destructive"
              size="lg"
              className="rounded-full w-16 h-16"
              onClick={handleReject}
              data-testid="reject-call-btn"
            >
              <PhoneOff className="w-8 h-8" />
            </Button>

            <Button
              size="lg"
              className="rounded-full w-16 h-16 bg-green-600 hover:bg-green-700"
              onClick={handleAccept}
              data-testid="accept-call-btn"
            >
              <Phone className="w-8 h-8" />
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
